export const softColors = {
    primary: "#6B7280",
    background: "#F9FAFB",
    border: "#E5E7EB",
    hover: "#F3F4F6",
    success: "#84cc16",
    error: "#ef4444",
    text: "#374151",
    secondaryText: "#6B7280",
  };